var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('intro'),_c('priced-to-go',{attrs:{"title":'renting'}}),_c('search',{attrs:{"search-url":'/rent',"min-title":'Minimum Rental Price',"max-title":'Maximum Rental Price'}}),_c('recently-added',{attrs:{"vehicle-url":"bankds/staff/rentalvehicle/latestvehicles"}}),_c('get-started-rent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }